import { useEffect } from "react";
import { Spinner } from "zudoku/components";
import { useAuth } from "zudoku/hooks";

import "./require-auth.css";

const RequireAuth = ({ children }: { children: React.ReactNode }) => {
  const { isAuthEnabled, isAuthenticated, isPending, login } = useAuth();

  useEffect(() => {
    if (!isAuthEnabled || isAuthenticated || isPending) {
      return;
    }

    void login({
      redirectTo: window.location.pathname + window.location.search,
      
    });
  }, [isAuthEnabled, isAuthenticated, isPending, login]);

  if (!isAuthEnabled) {
    return (
      <div role="status" aria-live="polite" className="require-auth-alert">
        This page requires an authenticated session, but authentication is currently disabled for this site.
      </div>
    );
  }

  if (isPending || !isAuthenticated) {
    return (
      <div role="status" aria-live="polite" className="require-auth-spinner">
        <Spinner size={18} />
        <span>Checking your authentication status…</span>
      </div>
    );
  }

  // If authenticated, render the MDX content
  return <>{children}</>;
};

export default RequireAuth;
